import ExaminationQuestionTable from './ExaminationQuestionTable';

export default ExaminationQuestionTable;
